<script setup lang="ts">
import type inputFullPhone from '@/components/base/form/InputFullPhone.vue';

const inputPhoneRef = ref<InstanceType<typeof inputFullPhone> | null>(null);

const selectedPhoneNumber = computed(() => {
  return inputPhoneRef.value?.selectedPhoneNumber ?? '';
});

const selectedPhoneDdi = computed(() => {
  return inputPhoneRef.value?.selectedPhoneDdi ?? '';
});

defineExpose({
  selectedPhoneNumber,
  selectedPhoneDdi,
});
</script>

<template>
  <div :class="$style.astroPayInfo">
    <div class="form-group">
      <label for="phone">
        {{ $t('account.phone') }}
      </label>

      <BaseFormInputFullPhone ref="inputPhoneRef" />
    </div>

    <div
      :class="$style.methodAlert"
      v-html="$t('withdraw.astropay.info_phone')"
    >
    </div>
  </div>
</template>

<style module lang="scss">
.astroPayInfo {
  .myPhone {
    @apply text-auth-texts flex items-center gap-x-2 text-base flex-wrap gap-y-0 leading-6;
    .changeButton {
      @apply text-xs ml-1 inline-flex text-auth-links;
    }
  }
  .methodAlert {
    @apply text-warning text-xs mt-3;
  }
}
</style>
